/**
 * 把对象转换成查询字符串
 * {"a": 1, "b": 2} -> a=1&b=2
 * @param obj
 * @returns {string}
 */
export function objectToQueryString(obj) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p] || ''));
    }
  return str.join("&");
}

/**
 * 垂直滚动条配置
 * @returns Objects
 */
export const scrollOptionsV = () => ({
    scrollPanel: {
        scrollingX: false,
        scrollingY: true
    },
    bar: {
        keepShow: true,
        background: '#7F7F7F',
        size: '6px'
    }
});

/**
 * 水平滚动条配置
 * @returns Objects
 */
export const scrollOptionsH = () => ({
    scrollPanel: {
        scrollingX: true,
        scrollingY: false
    },
    bar: {
        keepShow: true,
        background: '#9F9F9F',
        size: '6px'
    }
});